import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTreehouseComponent } from './simple-icons-treehouse.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTreehouseComponent ],
    exports:      [ SimpleIconsTreehouseComponent ],
    bootstrap:    []
})
export class SimpleIconsTreehouseModule {}
